import { useState } from 'react'
import { Dropdown } from '../../shared/dropdown/dropdown'
import { NormalText, TextFieldStyled } from '../../shared/styles'
import { ContainerStyled } from '../home/styles'
import { coins, networks } from '../mockedData'
import { Box } from '@mui/material'
import { Button } from '../../shared/button/button'
import { ContainerSwapStyled } from './swap-container.styled'
import { useTheme } from '@mui/material/styles'
import {
  checkSwapComission,
  createSwapTransaction,
} from '../../redux/actions/transactions.actions'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export const SwapContainer = ({ clientApiKey }) => {
  const [fields, setFields] = useState({
    fromNetwork: networks[0].value,
    fromCoin: coins?.find((coin) => coin.value === 'USDT')?.value,
    toNetwork: networks[1].value,
    toCoin: coins?.find((coin) => coin.value === 'USDT')?.value,
    amount: 0,
  })

  const {
    swap: {
      comission: {
        data: swapComissionData,
        isLoading: isLoadingSwapComissionData,
        error: errorSwapComissionData,
      },
      transaction: {
        data: swapTransactionData,
        isLoading: isLoadingSwapTransactionData,
        error: errorSwapTransactionData,
      },
    },
  } = useSelector((state) => state.transactions)

  const { palette } = useTheme()
  const dispatch = useDispatch()

  function handleChangeNetwork(network, type) {
    const otherType = type === 'fromNetwork' ? 'toNetwork' : 'fromNetwork'
    const isSameNetwork = network === fields[otherType]

    setFields({
      ...fields,
      [type]: network,
      [otherType]: isSameNetwork ? fields[type] : fields[otherType],
    })
  }

  function checkComission() {
    dispatch(checkSwapComission({ clientApiKey, ...fields }))
  }

  function handleSwap() {
    dispatch(createSwapTransaction({ clientApiKey, ...fields }))
  }

  return (
    <ContainerStyled>
      <NormalText color="#0F110C" size={14}>
        Swap between your tokens from different networks. Take into account the
        fee of the transaction.
      </NormalText>
      <NormalText>
        Right now, the only supported swap is between USDT on Polygon and Tron.
      </NormalText>
      <Box
        display={'flex'}
        flexDirection={'column'}
        width={'fit-content'}
        margin={'16px auto 0 auto'}
        border={`1px solid ${palette.grey[2]}`}
        borderRadius={'8px'}
        padding={'16px'}
      >
        {!swapTransactionData && <>
          <ContainerSwapStyled>
            <Box display={'flex'} gap={'8px'} flexDirection={'column'}>
              <NormalText>From</NormalText>
              <Dropdown
                withSearch={false}
                options={networks}
                defaultValue={fields.fromNetwork}
                onSelect={(network) =>
                  handleChangeNetwork(network, 'fromNetwork')
                }
                width={'184px'}
              />
              <Dropdown
                withSearch={false}
                options={coins?.filter((coin) => coin.value === 'USDT')}
                defaultValue={fields.fromCoin}
                onSelect={(coin) => setFields({ ...fields, fromCoin: coin })}
                width={'184px'}
              />
            </Box>

            <Box display={'flex'} gap={'8px'} flexDirection={'column'}>
              <NormalText>To</NormalText>
              <Dropdown
                withSearch={false}
                options={networks}
                defaultValue={fields.toNetwork}
                onSelect={(network) => handleChangeNetwork(network, 'toNetwork')}
                width={'184px'}
              />
              <Dropdown
                withSearch={false}
                options={coins?.filter((coin) => coin.value === 'USDT')}
                defaultValue={fields.toCoin}
                onSelect={(coin) => setFields({ ...fields, toCoin: coin })}
                width={'184px'}
              />
            </Box>
          </ContainerSwapStyled>
          <TextFieldStyled
            label={'Amount'}
            value={fields.amount}
            onChange={(e) => setFields({ ...fields, amount: e.target.value })}
            disabled={isLoadingSwapComissionData || isLoadingSwapTransactionData}
            sx={{
              margin: '24px 0 8px 0',
            }}
          />
          {(errorSwapComissionData || errorSwapTransactionData) && (
            <Box>
              <NormalText color={palette.primary[2]}>
                {errorSwapComissionData ?? errorSwapTransactionData}
              </NormalText>
            </Box>
          )}
          {swapComissionData && (
            <Box display={'flex'} flexDirection={'column'} gap={'4px'}>
              <NormalText>
                You will pay{' '}
                {(
                  Math.ceil(
                    (parseFloat(fields.amount) - parseFloat(swapComissionData)) *
                    100
                  ) / 100
                ).toFixed(2)}{' '}
                {fields.fromCoin}
              </NormalText>
              <NormalText color={palette.primary.main}>
                You will receive {swapComissionData} {fields.toCoin}
              </NormalText>
              <NormalText>
                Please take into account that this is an estimate and the actual amount may vary.
              </NormalText>
            </Box>
          )}
          <Box display={'flex'} flexDirection={'column'} gap={'8px'} mt={'8px'}>
            <Button
              onClick={checkComission}
              label={'Check comission'}
              containerStyles={{ width: '100%' }}
              isLoading={isLoadingSwapComissionData}
              endIcon={'CheckCircle'}
              iconColor={swapComissionData ? palette.primary.main : palette.grey[4]}
              iconWeight={swapComissionData ? 'fill' : 'regular'}
            />
            <Button
              onClick={handleSwap}
              label={'Swap'}
              containerStyles={{ width: '100%' }}
              isLoading={isLoadingSwapTransactionData}
              isDisabled={!swapComissionData}
              tooltipLabel={!swapComissionData ? 'You need to check the comission first' : null}
            />
          </Box>
        </>
        }
        {swapTransactionData && (
          <Box display={"flex"} flexDirection={'column'} gap={'4px'} borderRadius={'8px'} padding={'16px'} backgroundColor={palette.grey[3]}>
            <NormalText color={palette.primary.main} fontWeight={'bold'} size={14}>
              Transaction created successfully
            </NormalText>
            <NormalText>
              You will receive an estimation of {swapComissionData} {fields.toCoin}.
            </NormalText>
            <NormalText>
              You can track the status of your transaction in the <Link to={'/transactions'} style={{
                color: palette.primary.main,
                textDecoration: 'none',
              }}>transactions</Link> section.
            </NormalText>
            <NormalText>
              The transaction will be executed in a few minutes.
            </NormalText>
          </Box>
        )}
      </Box>
    </ContainerStyled>
  )
}
